/**
 * OrbitPrint — the plan notice (slice 4). Two kinds, both dismissible per person (owner:
 * "make sure you tell them what will happen, and make sure the notification can be closed"):
 *   grace      — "Your Premium plan ended on Sep 19. Everything keeps working until Sep 22…"
 *   downgraded — "X is now on the Free plan. Paused: 5 locations, 9 members. Nothing was deleted…"
 * A NEW event has a new key and shows again after an old dismissal.
 */
import { Link } from 'react-router-dom';
import { usePlan } from '../plan';
import { useOrbitAuth, useOrbitPath } from '../OrbitAuthContext';

export default function PlanBanner() {
  const { plan, dismissNotice } = usePlan();
  const { org } = useOrbitAuth();
  const p = useOrbitPath();
  const n = plan?.notice;
  if (!n) return null;
  const manager = org?.role === 'owner' || org?.role === 'admin';
  const pausedLocations = plan?.paused?.locations || 0;
  return (
    <section role="status" data-testid="orbit-plan-notice" data-kind={n.kind}
      className="orbit-boot orbit-d1 mt-6 p-5 sm:p-6 flex flex-wrap items-start justify-between gap-4"
      style={{ background: 'rgba(255,176,32,.10)', border: '1px solid rgba(255,176,32,.45)', borderRadius: 12 }}>
      <div className="min-w-0 flex-1">
        <p className="orbit-label m-0" style={{ color: 'var(--ob-amber)' }}>{n.kind === 'grace' ? 'Your plan' : 'Plan changed'}</p>
        <h3 className="orbit-display mt-1" style={{ fontSize: 24 }}>{n.title}</h3>
        <p className="orbit-ink2 text-[15px] leading-relaxed mt-2 m-0">{n.body}</p>
        {manager && n.kind === 'downgraded' && pausedLocations > 0 && (
          <p className="text-sm mt-2 m-0 orbit-muted">
            The oldest location stays active. Want a different one? Use <strong style={{ color: 'var(--ob-ink)' }}>Make active</strong> on its card below.
          </p>
        )}
        <div className="flex flex-wrap gap-4 mt-3 text-sm">
          <Link to={p('/plans')} className="orbit-link" data-testid="orbit-plan-notice-plans">See the plans</Link>
        </div>
      </div>
      <button type="button" onClick={() => dismissNotice(n.key)} className="orbit-btn is-quiet is-small" aria-label="Close this notice" data-testid="orbit-plan-notice-dismiss">
        Close
      </button>
    </section>
  );
}
